import { useEffect, useState } from "react";

function YearSelection({ minValue, maxValue, filter, onChange }) {
    const [rangeOneValue, setRangeOneValue] = useState(minValue)
    const [rangeTwoValue, setRangeTwoValue] = useState(maxValue)

    useEffect(() => {
        if (filter.startYear === "")
            setRangeOneValue(minValue)
        else
            setRangeOneValue(filter.startYear)
        
        setRangeTwoValue(filter.endYear)

    }, [ filter, minValue ])

    const slideOne = ( e ) => {
        let newValue = e.target.value

        onChange({"lowRange": newValue, "highRange": rangeTwoValue})
    }
    const slideTwo = ( e ) => {
        let newValue = e.target.value

        onChange({"lowRange": rangeOneValue, "highRange": newValue})
    }

    return (
        <div>
            <label className="field-label">Year Range</label>

            <div className='year-selection-input-holder'>
                <input className='year-selection-input' value={rangeOneValue} type='number' onInput={slideOne}/>
                <div>-</div>
                <input className='year-selection-input' value={rangeTwoValue} type='number' onInput={slideTwo}/>
            </div>
        </div>
    )
}

export default YearSelection;